import { UpdateDeviceWifiStatus } from "@/actions/deviceActions";

// eslint-disable-next-line import/prefer-default-export
export const changeDeviceWifiStatus = (value) => (dispatch, getState) => {
  const { deviceStore } = { ...getState() };
  const { WifiStatus } = deviceStore;
  if (WifiStatus !== value) dispatch(UpdateDeviceWifiStatus(value));
};
